import React, { useState } from "react";
import InputMask from "react-input-mask";

import FormField from "@/components/atoms/FormField";
import ManualMaskInput from "./ManualMaskInput";

interface InputMaskWrapperProps {
  mask: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  required?: boolean;
  variant?: "standard" | "outlined" | "filled";
  name: string;
  label: string;
  fullWidth?: boolean;
  InputLabelProps?: object;
  error?: boolean;
  helperText?: string;
  dynamicMask?: boolean;
  [key: string]: any;
}

const InputMaskWrapper: React.FC<InputMaskWrapperProps> = ({
  mask,
  value,
  onChange,
  disabled = false,
  required = false,
  variant = "standard",
  name,
  label,
  fullWidth = true,
  InputLabelProps = { shrink: true },
  error = false,
  helperText = "",
  dynamicMask = false,
  ...otherProps
}) => {
  const [useManualMask, setUseManualMask] = useState(false);

  // Garantir que disabled seja sempre um boolean válido
  const safeDisabled = Boolean(disabled);
  const safeRequired = Boolean(required);
  const safeError = Boolean(error);

  // Forçar uso de ManualMaskInput se houver problemas com valores
  if (value === undefined || value === null || mask === undefined || mask === null) {
    return (
      <ManualMaskInput
        mask={mask || ""}
        value={value || ""}
        onChange={onChange}
        disabled={safeDisabled}
        required={safeRequired}
        variant={variant}
        name={name}
        label={label}
        fullWidth={fullWidth}
        InputLabelProps={InputLabelProps}
        error={safeError}
        helperText={helperText}
        dynamicMask={dynamicMask}
        {...otherProps}
      />
    );
  }

  // Use ManualMaskInput as the primary implementation for reliability
  // react-input-mask has compatibility issues with the current setup
  return (
    <ManualMaskInput
      mask={mask}
      value={value}
      onChange={onChange}
      disabled={safeDisabled}
      required={safeRequired}
      variant={variant}
      name={name}
      label={label}
      fullWidth={fullWidth}
      InputLabelProps={InputLabelProps}
      error={safeError}
      helperText={helperText}
      dynamicMask={dynamicMask}
      {...otherProps}
    />
  );
};

export default InputMaskWrapper;
